




































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class LeafItem extends Vue {
  @Prop() modelWrapper!: any;
  @Prop() modelKey!: string;
  @Prop() row!: any;
  @Prop() resultIndex!: any;
  @Prop() indicatorIndex!: any;
  @Prop() readOnly: boolean;

  get yesNo() {
    return [this.$t('Yes'), this.$t('No')];
  }

  get datum() {
    let modelKeys = (this.modelKey || "").toString().split(".");
    var model = this.modelWrapper;
    modelKeys.forEach((key) => {
      key = key.replace(/%2E/g, '.');
      if (model[key]) {
        model = model[key];
      } else {
        model[key] = {};
        model = model[key];
      }
    });
    return model;
  }

  toggleInput(value) {
    if(value.target.checked) {
      this.datum.baselineunknown = true;
      this.datum.baseline = null;
    }
    else
      this.datum.baselineunknown = false;
  }
}
